import React, { useState, useRef, useEffect } from 'react'
import ListContent from './components/List'
import TicketInfo from './components/TicketInfo'
import ImageModal from '@feedback/components/ImageModal'
import {
  List,
  InputItem,
  ImagePicker,
  WhiteSpace,
  Toast,
  Icon,
  Button
} from 'antd-mobile'
import {
  getFeedbackInfo,
  getFeedbackDetail,
  addReply,
  uploadFile,
  closeFeedback
} from '@feedback/services/index'
import { useRequest } from 'ahooks'
import CommonModal from '@feedback/components/CommonModal'
import { getTextByKey, reportFn } from '@feedback/utils/util'
import qs from 'qs'
import './App.scss'

interface Props {
  history: {
    location: {
      search: string
    }
    replace: any
  }
  match: any
}
const LIMIT = 20 // 每页的数据量
//工单详情+回复列表+用户回复功能
function App({ history }: Props) {
  const [isShowModal, toggleShowModal] = useState<boolean>(false) // 处理结束问题modal
  const [page, setPage] = useState(1) // 当前分页页码
  const [count, setCount] = useState(-1) // 当前总数
  const [list, setList] = useState<any[]>([]) // 列表
  const [curImage, setCurImage] = useState<string>('') // 当前大图图片地址
  const [isShowImageModal, toggleShowImageModal] = useState(false) // 大图模态框显示状态
  const [inputText, setInputText] = useState<string>('')
  const [lastScrollHeight, setScrollHeight] = useState(0)
  const [uploadFiles, setUploadFile] = useState<any[]>([])
  const [isComplete, setCompleteStatus] = useState<boolean>(false)
  const scrollEl = useRef<HTMLDivElement>(null)
  const feedback_id: any = qs.parse(history.location.search.split('?')[1])
    .feedback_id
  const { data: ticketInfo } = useRequest(() =>
    getFeedbackInfo({ feedback_id })
  )
  const { run: closeFeedbackFun } = useRequest(closeFeedback, {
    manual: true,
    onSuccess: (result) => {
      const { code, message } = result
      if (code === 0) {
        Toast.success(message, 1)
        closeShowModal()
        setTimeout(() => {
          history.replace(`/v1/ticketList?feedback_id=${feedback_id}`)
        }, 0)
      } else {
        Toast.info(message, 2)
      }
    }
  })
  const closeShowModal = () => {
    toggleShowModal(false)
  }
  //点击Resolved按钮
  const openShowModal = () => {
    reportFn({ parm1: 5, parm2: 1, parm6: feedback_id })
    toggleShowModal(true)
  }
  // 点击确认弹窗confirm
  const confirmModal = () => {
    reportFn({ parm1: 5, parm2: 2, parm6: feedback_id })
    closeFeedbackFun({ feedback_id: feedback_id })
  }

  const openImageModal = (imgSrc: string): void => {
    imgSrc !== curImage && setCurImage(imgSrc)
    toggleShowImageModal(true)
  }
  // 滚动到底部
  const scrollToBottom = (el: any): void => {
    if (el) {
      el.scrollTop = el.scrollHeight - el.clientHeight
    }
  }
  const scrollEvent = () => {
    if (!scrollEl || loadingList || (count !== -1 && count <= list.length)) {
      return
    }
    if (scrollEl.current && scrollEl.current.scrollTop < 20) {
      getReplyList({ feedback_id, page: page, limit: LIMIT })
    }
  }
  // 处理加载回复列表请求
  const { loading: loadingList, run: getReplyList } = useRequest(
    getFeedbackDetail,
    {
      manual: true,
      onSuccess: (result) => {
        const { data, code } = result
        if (code === 0) {
          // 页码为1，初次加载，滚动到页面底部
          if (page === 1) {
            setTimeout(() => {
              scrollToBottom(scrollEl.current)
            }, 0)
          } else {
            if (scrollEl.current) {
              scrollEl.current.scrollTop =
                scrollEl.current.scrollHeight - lastScrollHeight
              setScrollHeight(scrollEl.current.scrollHeight)
            }
          }
          setPage((page) => page + 1)
          count !== data.count && setCount(data.count)
          data.list.length > 0 &&
            setList((curList) => [...data.list, ...curList])
        }
      }
    }
  )
  useEffect(() => {
    getReplyList({ feedback_id, page: 1, limit: LIMIT })
  }, [getReplyList, feedback_id])

  const { run: replySubmit } = useRequest(addReply, {
    manual: true,
    onSuccess: (result) => {
      const { code } = result
      const date = new Date()
      const time = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
      if (code === 0) {
        const listItem = {
          reply_content: inputText,
          _id: new Date().getTime(),
          created_at: time,
          push_user_type: 1,
          image_list: []
        }
        setInputText('')
        setList([...list, listItem])
        setCount(count + 1)
        scrollToBottom(scrollEl.current)
      }
    }
  })
  const { run: replySubmitImage } = useRequest(addReply, {
    manual: true,
    onSuccess: (result) => {
      const { code } = result
      if (code === 0) {
        const date = new Date()
        const time = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        const listItem = {
          reply_content: '',
          _id: new Date().getTime(),
          create_at: date,
          push_user_type: 1,
          image_list: [uploadFiles[0].url]
        }
        setList([...list, listItem])
        setCount(count + 1)
        scrollToBottom(scrollEl.current)
      }
    }
  })

  const handlerInputSumbit = () => {
    if (inputText) {
      replySubmit({ reply_content: inputText, feedback_id, push_user_type: 1 })
    }
  }

  const handlerPictureUpload = (files: any[]) => {
    if (files.length > 0) {
      const targetFiles = files.slice(files.length - 1, files.length)
      uploadPicture({ files: targetFiles })
      setUploadFile(targetFiles)
    } else {
      setUploadFile([])
    }
  }

  const onChangeInput = (value: string) => {
    setInputText(value)
  }

  const { loading: loadingUpload, run: uploadPicture } = useRequest(
    uploadFile,
    {
      manual: true,
      onSuccess: (result) => {
        const { data, code } = result
        if (code === 0) {
          replySubmitImage({
            feedback_id,
            push_user_type: 1,
            image_upload_key: data.upload_key
          })
        }
      }
    }
  )
  const inputFocus = () => {
    setTimeout(function () {
      window.scrollTo(0, document.body.clientHeight)
    }, 500)
  }

  useEffect(() => {
    document.title = getTextByKey('service detail')
  }, [])

  useEffect(() => {
    if (
      ticketInfo?.data &&
      (ticketInfo.data.feedback_status === 4 ||
        ticketInfo.data.feedback_status === 5)
    ) {
      setCompleteStatus(true)
    }
  }, [ticketInfo])
  return (
    <div className='p-ticket-detail'>
      <div className='list-wrapper' ref={scrollEl} onScroll={scrollEvent}>
        {ticketInfo && (
          <TicketInfo
            ticketInfo={ticketInfo.data}
            openImageModal={openImageModal}
          />
        )}
        <WhiteSpace />
        <ListContent
          list={list}
          count={count}
          loadingList={loadingList}
          openShowModal={openShowModal}
          isComplete={isComplete}
          openImageModal={openImageModal}
        />
      </div>
      {ticketInfo && !isComplete && (
        <div className='c-input-wrapper'>
          <div className='input-box'>
            {/* 输入框1 */}
            <List>
              <InputItem
                placeholder={getTextByKey('tip question2')} //'Are you satisfied with our service？'
                type='text'
                onChange={onChangeInput}
                value={inputText}
                extra={
                  <Button
                    className='btn-send'
                    type='primary'
                    size='small'
                    onClick={handlerInputSumbit}
                  >
                    {getTextByKey('send')}
                  </Button>
                }
                // onFocus={inputFocus}
              />
            </List>
          </div>
          {/* 上传功能 1*/}
          <div className='picture-box'>
            {loadingUpload ? (
              <Icon type='loading' />
            ) : (
              <ImagePicker length={1} onChange={handlerPictureUpload} />
            )}
          </div>
        </div>
      )}
      {isShowModal && (
        <CommonModal
          title={getTextByKey('notification')}
          desc={getTextByKey('tip close')}
          confirmText={getTextByKey('confirm')}
          cancelText={getTextByKey('back')}
          cancelFun={closeShowModal}
          confirmFun={confirmModal}
          closeFun={closeShowModal}
        />
      )}
      {isShowImageModal && (
        <ImageModal
          imgSrc={curImage}
          closeFun={() => {
            toggleShowImageModal(false)
          }}
        />
      )}
    </div>
  )
}

export default App
